const LABELS = {
  BUTTON_TITLE: 'Ativar alterações',
  SCHEDULE_BUTTON_TITLE: 'Agendar ativação'
};

export default LABELS;
